"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Statistics = (function () {
    function Statistics(response) {
        this.sum5 = 0;
        this.oddEven = 0;
        this.firstSum = 0;
        this.firstOddEven = 0;
        this.lastSum = 0;
        this.lastOddEven = 0;
        this.hotNumbers = this.decodeNumbers(response['HotNumbers']);
        this.coldNumbers = this.decodeNumbers(response['CoolNumbers']);
        window['hot-numbers'] = this.hotNumbers;
        window['cold-numbers'] = this.coldNumbers;
        this.topColor = this.decodeNumbers(response['TopColor']);
        this.sum5 = response['Sum5'];
        this.oddEven = response['OddEven'];
        this.firstColor = this.decodeNumbers(response['First_Color']);
        this.firstSum = response['First_Sum'];
        this.firstOddEven = response['First_OddEven'];
        this.lastColor = this.decodeNumbers(response['Last_Color']);
        this.lastSum = response['Last_Sum'];
        this.lastOddEven = response['Last_OddEven'];
    }
    Statistics.prototype.show = function () {
        this.showHotCold();
        var statisticsLoaded = window['statisticsLoaded'];
        if (typeof statisticsLoaded === 'undefined') {
            window['statisticsLoaded'] = 1;
        }
        else {
            return;
        }
        window['showCharts'](this.topColor, this.sum5, this.oddEven, this.firstColor, this.firstSum, this.firstOddEven, this.lastColor, this.lastSum, this.lastOddEven);
    };
    Statistics.prototype.compareNumbers = function (a, b) {
        return a - b;
    };
    Statistics.prototype.showHotCold = function () {
        $('#hot-six-holder').html('');
        $('#cold-six-holder').html('');
        this.hotNumbers.sort(this.compareNumbers);
        this.coldNumbers.sort(this.compareNumbers);
        for (var key in this.hotNumbers) {
            var ball = document.getElementById('ball' + this.hotNumbers[key]);
            if (null !== ball) {
                var clone = ball.cloneNode(true);
                $(clone).attr('id', 'hot-ball-' + this.hotNumbers[key]);
                $(clone).removeClass('clickable-ball');
                $('#hot-six-holder').append(clone);
            }
        }
        for (var key in this.coldNumbers) {
            var ball = document.getElementById('ball' + this.coldNumbers[key]);
            if (null !== ball) {
                var clone = ball.cloneNode(true);
                $(clone).attr('id', 'cold-ball-' + this.coldNumbers[key]);
                $(clone).removeClass('clickable-ball');
                $('#cold-six-holder').append(clone);
            }
        }
    };
    Statistics.prototype.decodeNumbers = function (numbersString) {
        var numbers = numbersString.split('|');
        delete numbers[numbers.length - 1];
        delete numbers[0];
        var numbersNew = [];
        for (var x in numbers) {
            numbersNew.push(parseInt(numbers[x]));
        }
        return numbersNew;
    };
    return Statistics;
}());
exports.default = Statistics;



//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/ts/statistics/statistics.ts
// module id = 1171
// module chunks = 2